// test2089
(2089 && 0);
